import { useEffect, useRef } from "react";

type UseEffectParams = Parameters<typeof useEffect>;

function useFirstEffect(cb: UseEffectParams[0]) {
  useEffect(cb, []);
}

function useFirstEffectIgnoreStrict(cb: UseEffectParams[0]) {
  const isInitialized = useRef({ value: false });

  useFirstEffect(() => {
    if (isInitialized.current.value) return;
    isInitialized.current.value = true;

    cb();
  });

  return isInitialized;
}

export { useFirstEffect, useFirstEffectIgnoreStrict };
